class billPreviewCtrl {
    constructor($scope, httpRequest, $location, $timeout, dictService, globalFn) {
        dictService.get('inv_type') // 发票种类  多一个卷票
        dictService.get('tax_includ') // 含税标志

        const { billId } = $location.search()
        $scope.currentPage2 = $location.search().currentPage
        $scope.billCode = $location.search().billCode
        $scope.maxSize2 = 1
        $scope.qryBillInvoice = {}
        // 分页获取发票详情列表 post_qryBillInvoice
        const qryBillInvoice = function () {
            const req = {

                pageNum: $scope.currentPage2,
                pageSize: 1,
                param: billId,

            }

            httpRequest.post_qryBillInvoice(req).then((res) => {
                $scope.qryBillInvoice.list = res.data.value.list
                console.log($scope.qryBillInvoice.list)
                for (const a in $scope.qryBillInvoice.list) {
                    $scope.qryBillInvoice.list[a].adValoremTotalChinese = globalFn.digitUppercase($scope.qryBillInvoice.list[0].adValoremTotal)
                }
                $scope.totalItems2 = res.data.value.total
                $scope.currentPage2 = ++res.data.value.prePage
                $scope.maxSize2 = res.data.value.pageSize
            })
        }
        $timeout(qryBillInvoice)

        $scope.pageChanged2 = function () {
            qryBillInvoice()
        }
    }
}
billPreviewCtrl.$inject = ['$scope', 'httpRequest', '$location', '$timeout', 'dictService', 'globalFn']
export default billPreviewCtrl



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/ovatBill/billPreviewCtrl.js